module.exports = __webpack_public_path__ + "static/fabricio-1-2-683x1024-a0d00590d23998b90e5423d235b7b681.jpg";